import { Component,Inject  } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {provideNativeDateAdapter} from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggle } from '@angular/material/slide-toggle';



@Component({
  selector: 'app-downloaddialog',
  providers: [provideNativeDateAdapter()],
  imports: [MatButtonModule,MatIconModule,FormsModule,MatInputModule,MatFormFieldModule,MatDatepickerModule,CommonModule,MatRadioModule,MatSlideToggle],
  templateUrl: './downloaddialog.component.html',
  styleUrl: './downloaddialog.component.css'
})
export class DownloaddialogComponent {
  //constructor(public dialogRef: MatDialogRef<DownloaddialogComponent>){}
  constructor(
    public dialogRef: MatDialogRef<DownloaddialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any // Ensure that MAT_DIALOG_DATA is correctly injected
  ,private http: HttpClient) {}
  verificationID=0;
  value = 'Clear me';
  location="";
  date="";
  phone="";
  otp="";
  name="";
  pax="";

  private apiUrlOTP = 'https://cpaas.messagecentral.com/verification/v3/send';
  private apiUrlValidateOtp='https://cpaas.messagecentral.com/verification/v3/validateOtp';
  generatedOTP="";
  flag:boolean=false;
  LeadData={
  flag:false,  
  name:'',
  location:'',
  phone:'',
  pax:'',
  date:'',
  event:'',
  menu:'',
  contacted:'',
  comments:''

}
isWhatsapp: boolean = false;
channel: string = "SMS";
 

  sendOTP() {
    var countrycode = "91";
    var customerID="C-EA70CB9EE0C9480";
    const url = `${this.apiUrlOTP}?countryCode=${countrycode.toString()}&customerId=${customerID}&flowType=SMS&mobileNumber=${this.phone}`;
    const options = {
      method: 'POST',
      headers: {
        'authToken': 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDLUVBNzBDQjlFRTBDOTQ4MCIsImlhdCI6MTc0NzMyOTgxMiwiZXhwIjoxOTA1MDA5ODEyfQ.Is4HL8YzwMfbU_XXv8gPsxNG-faLDujGHhIsl4xcugXixX-q96C_Ck08yE7s1b5BkjkqD_ZxQv5QEgtxmLgKZw'
      }
    };
    fetch(url, options)
      .then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        else
        {
          
          alert("OTP Sent Successfully")
        }
        const body = await response.json();
        this.verificationID=body.data.verificationId;
        console.log(body);
      })
      .catch(error => {
        console.error(error);
      });
    

  }

  

  async validateOTP(): Promise<boolean> {
    if(this.otp==="")
    {
      alert("Please enter a valid OTP");
      return false;
    }
    const countryCode = "91";
    const customerID = "C-EA70CB9EE0C9480";
    const url = `${this.apiUrlValidateOtp}?countryCode=${countryCode}&mobileNumber=${this.phone}&verificationId=${this.verificationID}&customerId=${customerID}&code=${this.otp}`;
    const options = {
      method: 'GET',
      headers: {
        'authToken': 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDLUVBNzBDQjlFRTBDOTQ4MCIsImlhdCI6MTc0NzMyOTgxMiwiZXhwIjoxOTA1MDA5ODEyfQ.Is4HL8YzwMfbU_XXv8gPsxNG-faLDujGHhIsl4xcugXixX-q96C_Ck08yE7s1b5BkjkqD_ZxQv5QEgtxmLgKZw'
      }
    };

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const body = await response.json();
      console.log(body);

      // If API returns string "200"
      if (body.data && body.data.responseCode === "200") {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  startdownload(){
    
    this.validateOTP().then(isValid => {
      if (isValid) {
        
        alert("OTP validated successfully!");
        this.flag=true;
        this.LeadData.flag=true;
        this.LeadData.name=this.name;
        this.LeadData.location=this.location;
        this.LeadData.date=this.date;
        this.LeadData.phone=this.phone;
        this.LeadData.pax=this.pax;
        this.dialogRef.close(this.LeadData);
        console.log("OTP is valid! Proceeding...");
      } else {
        alert("Invalid OTP or validation failed.");
        console.log("OTP validation failed.");
      }
    });

    
   
  }
 



}

